import __request__ from "routing/request";
export function getActive(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lakes/active", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/data_lakes/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getFields(data_lake_id, table_id, exclude_non_filterable = false, exclude_in_memory_filterable = false, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/data_lakes/fields/${data_lake_id}`, null, { "table_id": table_id, "exclude_non_filterable": exclude_non_filterable, "exclude_in_memory_filterable": exclude_in_memory_filterable }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
